import React from 'react';
import { at } from 'lodash';
import { useField } from 'formik';
import { TextField,InputAdornment } from '@material-ui/core';

export default function InputField(props,inputProps) {
  const { errorText, ...rest } = props;
  const [field, meta] = useField(props);

  function _renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');
    if (touched && error) {
      return error;
    }
  }
  function _inputProps() {
    const [touched, error] = at(meta, 'touched', 'error');
    if (touched && error) {
      return error;
    }
  }

  return (
    <TextField
      variant="outlined"
      type="text"
      error={meta.touched && meta.error && true}
      helperText={_renderHelperText()}
      {...field}
      {...rest}
      InputLabelProps={{
        shrink: true,
      }}
      InputProps={{
        endAdornment: props.inputPropsEnd ? <InputAdornment position="end">{props.inputPropsEnd}</InputAdornment>: '',
    }}
    />
  );
}
